import React from "react";
import ReactDOM from "react-dom/client";

import { Provider } from "react-redux";
import { store } from "./libraries/state_reducers/store";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-time-picker/dist/TimePicker.css";
//import "react-clock/dist/Clock.css";

import "./assets/fonts/gotham/style.css";
import "./assets/styles/style.min.css";
import "./assets/styles/style_rtl.min.css";

import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("./firebase-messaging-sw.js")
    .then(function (registration) {
      //console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(function (err) {
      //console.log("Service worker registration failed, error:", err);
    });
}

/* const root = ReactDOM.createRoot(
  document.getElementById("root")! as HTMLElement
); */

const root = ReactDOM.createRoot(document.getElementById("root")!);
const GOOGLE_client_id: string =
  process.env.REACT_APP_social_google_client_id ?? "";

root.render(
  <GoogleOAuthProvider clientId={GOOGLE_client_id}>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </GoogleOAuthProvider>
);

// React.StrictMode will load twice
/* root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
